import type { AuditLogEntry, AuditLogFilterOptions } from "@crewledger/shared/schemas";
import { apiFetch, downloadAuthenticatedFile } from "@/lib/api";

export async function fetchAuditLogs(params?: {
  page?: number;
  pageSize?: number;
  actorId?: string;
  action?: string;
  actionPrefix?: string;
  siteId?: string;
  payPeriodId?: string;
  dateFrom?: string;
  dateTo?: string;
  q?: string;
}) {
  const search = new URLSearchParams();
  if (params?.page) search.set("page", String(params.page));
  if (params?.pageSize) search.set("pageSize", String(params.pageSize));
  if (params?.actorId) search.set("actorId", params.actorId);
  if (params?.action) search.set("action", params.action);
  if (params?.actionPrefix) search.set("actionPrefix", params.actionPrefix);
  if (params?.siteId) search.set("siteId", params.siteId);
  if (params?.payPeriodId) search.set("payPeriodId", params.payPeriodId);
  if (params?.dateFrom) search.set("dateFrom", params.dateFrom);
  if (params?.dateTo) search.set("dateTo", params.dateTo);
  if (params?.q) search.set("q", params.q);

  const qs = search.toString();
  return apiFetch<{ data: AuditLogEntry[]; meta: { total?: number } }>(
    `/api/audit-log${qs ? `?${qs}` : ""}`,
  );
}

export async function fetchAuditLogOptions() {
  return apiFetch<{ data: AuditLogFilterOptions }>("/api/audit-log/options");
}

export function buildAuditExportUrl(params: Record<string, string | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value) search.set(key, value);
  }
  const qs = search.toString();
  return `/api/audit-log/export${qs ? `?${qs}` : ""}`;
}

export async function downloadAuditExportCsv(
  params: Record<string, string | undefined>,
): Promise<void> {
  await downloadAuthenticatedFile(buildAuditExportUrl(params), "werkio-audit.csv");
}
